<template>
  <tooltip-hover
    :text="$t('exclude')"
    primary
    position="top left"
    class="tw-flex tw-ml-2 tw-self-center"
  >
    <button class="tw-group" @click="$emit('input')">
      <font-awesome-icon
        icon="minus"
        size="xs"
        class="tw-rounded-sm tw-p-0.5 tw-size-2 tw-self-center tw-text-dark"
        :class="
          toggled
            ? 'tw-bg-danger group-hover:tw-bg-danger-hover'
            : 'tw-bg-[var(--input-background-alt-color)] game-input-background-color'
        "
      />
    </button>
  </tooltip-hover>
</template>

<script>
import TooltipHover from '@components/Message/TooltipHover.vue'

export default {
  components: {
    TooltipHover,
  },
  props: {
    toggled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
}
</script>
